export default {
  "content": "<path d=\"M23.781 19.08L13.431 1.314a1.666 1.666 0 00-2.862 0L.219 19.08A1.619 1.619 0 001.65 21.5h20.7a1.618 1.618 0 001.431-2.42zM12 18.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.5-6a1.5 1.5 0 11-3 0V8a1.5 1.5 0 013 0v4.5z\" fill=\"#F76902\"/>",
  "attrs": {
    "width": "24",
    "height": "22",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};